import ImmersiveBlock from './immersive-block';

const immersiveBlockConfig = {
  name: 'immersiveBlock',
  class: ImmersiveBlock,
  querySelector: {},
  options: {},
};

export default immersiveBlockConfig;
